async function handleSubmit(event) {
  event.preventDefault()

  const dealerForm = document.querySelector('#jsRetailerFormEl')
  const result = document.querySelector('#errorMessages')
  const submitButton = document.querySelector('#jsRetailerFormSubmit')
  const successMsg = document.querySelector('#jsRetailerFormSuccessMsg')
  const formEl = document.querySelector('#jsRetailerFormEl')

  submitButton.classList.add('in--progress')
  successMsg.classList.remove('que-form__box--message-show')
  result.classList.remove('que-form__box--message-show')

  try {
    const { method, action } = event.target
    const body = new URLSearchParams(new FormData(event.target))

    const response = await fetch(action, { method, body })

    const responseBody = await response.json()

    if (!response.ok) {
      throw new Error(
        responseBody.message || `HTTP error! Status: ${response.status}`
      )
    }

    result.innerHTML = JSON.stringify(responseBody, null, 2)
    successMsg.classList.add('que-form__box--message-show')
    // formEl.reset();
  } catch (error) {
    result.innerHTML = `Failed to process request: ${error.message}`
    result.classList.add('que-form__box--message-show')
  } finally {
    submitButton.classList.remove('in--progress');
    // reset the form
    dealerForm.reset();
  }
}
